import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveCentroCustoBloqueado({ commit }, data) {
      try {
        return await api.post('/centros-custos/bloqueados', data)
      } catch (error) {
        throw error
      }
    },

    async saveCentroCustoBloqueadoFromFile({ commit }, data) {
      try {
        return await api.post('/centros-custos/bloqueados/file', data)
      } catch (error) {
        throw error
      }
    },

    async getCentrosCustosBloqueados({ commit }) {
      try {
        const response = await api.get('/centros-custos/bloqueados')

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async deleteCentroCustoBloqueado({ commit }, ccBloqueadoId) {
      try {
        return await api.delete(`/centros-custos/bloqueados/${ccBloqueadoId}`)
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
